module.exports = __webpack_public_path__ + "img/vulcans-sub-features-1.9876e29.jpg";